import { reactive } from "vue";

export const bookPageStore = reactive({
    isHidden: false,
    
})